import { FC } from "react";

import DeleteModal from "../../common/DeleteModal";
import { queryKeys } from "../../../services/react-query/queryKeys";
import { deleteBreak } from "../../../network/workingHours";

interface DeleteTimeOffProps {
  visible: boolean;
  onClose: () => void;
  timeOffId: any;
  teamMemberId: any;
  locationId: number;
}

const DeleteTimeOff: FC<DeleteTimeOffProps> = ({
  visible,
  onClose,
  timeOffId,
  teamMemberId,
  locationId,
}) => {
  return (
    <DeleteModal
      visible={visible}
      onClose={onClose}
      onDelete={deleteBreak}
      data={{ locationId, teamMemberId, breakId: timeOffId }}
      optionalParam2={timeOffId}
      confirmationHeader="هل انت متأكد من حذف الفترة؟"
      confirmationText=""
      queryKey={queryKeys.workingHours}
      successMessage="Time off deleted successfully"
    />
  );
};

export default DeleteTimeOff;
